<template>
  <v-container v-if="items.length" class="py-10 py-md-13 py-lg-16">
    <div v-if="smAndDown" class="text-center mb-4 item-title">
      <span class="font-montserrat">PROTOCOLO</span>
      <span class="ml-4 font-audacity">azul</span>
    </div>

    <v-row
      class="item"
      :class="{ 'mt-10 mt-md-16': keyItems > 0 }"
      justify="center"
      align="center"
      v-for="({ img, text }, keyItems) in items"
      :key="keyItems"
    >
      <v-col
        :class="{
          'pr-md-14': keyItems % 2 == 0,
          'pl-md-14': keyItems % 2 != 0,
        }"
        cols="12"
        md="6"
        order="12"
        :order-md="keyItems % 2 == 0 ? 0 : 12"
      >
        <div v-if="!smAndDown && keyItems === 0" class="mb-4 item-title">
          <span class="font-montserrat">PROTOCOLO</span>
          <span class="ml-4 font-audacity">azul</span>
        </div>

        <div
          class="text-center text-md-left font-montserrat item-text"
          v-html="text"
        ></div>
      </v-col>

      <v-col
        v-if="img"
        cols="12"
        md="6"
        order="0"
        :order-md="keyItems % 2 == 0 ? 12 : 0"
      >
        <img :src="files + img" class="d-block item-img" width="100%" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
const _config = {
  mod: "blueProtocolAngels",
};

export default {
  created() {
    this.$rest(_config.mod).get();
  },
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-title {
    span {
      &:first-child {
        color: #58595b;
        font-size: 45px;
        font-weight: 700;

        @media screen and (max-width: 600px) {
          font-size: 28px;
        }
      }

      &:last-child {
        color: #00567c;
        font-size: 78px;

        @media screen and (max-width: 600px) {
          font-size: 48px;
        }
      }
    }
  }

  &-text {
    color: #58595b;
  }

  &-img {
    aspect-ratio: 555 / 370;
    border-radius: 32px;
    object-fit: cover;
    -o-object-fit: cover;
  }
}
</style>
